/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import qs from 'query-string'
import moment from 'moment'

import Request from 'generic/request/Request'

export const INTERPRETERS_URL = '/api/interpreter/list/'
export const SIMPLE_INTERPRETERS_URL = '/api/simple/interpreter/list/'
const INTERPRETER_URL = '/api/interpreter/'

export function getInterpreters (text) {
  const query = {
    search: 'text:' + text,
    page_size: 10,
    meta: false,
    objects_count: false,
    is_active: true
  }

  return Request.getRequest(SIMPLE_INTERPRETERS_URL + '?' + qs.stringify(query))
    .then((results) => {
      return results.data.objects.objects
    })
}

export function getInterpreter (uid) {
  return Request.getRequest(INTERPRETER_URL + (uid ? uid + '/' : ''))
    .then((result) => {
      return result.data.object
    })
}

const isIncluded = (needle, stack) => {
  const stackStart = moment(stack.start, 'YYYY-MM-DD HH:mm:ss')
  const stackEnd = moment(stack.end, 'YYYY-MM-DD HH:mm:ss')

  const needleStart = moment(needle.start, 'YYYY-MM-DD HH:mm:ss')
  const needleEnd = moment(needle.end, 'YYYY-MM-DD HH:mm:ss')

  return needleStart.isSameOrAfter(stackStart) && needleEnd.isSameOrBefore(stackEnd)
}

const mergeAvailabilities = (availabilities) => {
  if (!availabilities || availabilities.length <= 1) {
    return availabilities
  }

  let cursor = 0
  while (cursor + 1 < availabilities.length) {
    const first = availabilities[cursor]
    const next = availabilities[cursor + 1]

    if (isIncluded(first, next)) { // If first in included in next, delete first
      availabilities.splice(cursor, 1)
    } else if (isIncluded(next, first)) { // If next is included in first, delete next
      availabilities.splice(cursor + 1, 1)
    } else {
      cursor++
    }
  }

  return availabilities
}

export function getInterpreterAvailabilities (matching) {
  /*
   * This extract every availability slots
   * concat them all in one array
   * sort them by start date and merge similar slots
  */
  let availabilities = matching.data.objects.objects
    .map(item => (item.availabilities))
    .reduce((res, availability) => {
      res = [...res, ...availability]

      return res
    }, [])
    .sort((a, b) => {
      if (moment(a.start).isBefore(moment(b.start))) {
        return -1
      } else if (moment(a.start).isAfter(moment(b.start))) {
        return 1
      }

      return 0
    })

  return mergeAvailabilities(availabilities)
}



// WEBPACK FOOTER //
// ./src/actions/Interpreter.js